export const BAR_HEIGHT = 40;
export const BAR_PADDING = 2;
export const TEXT_DY = 25;

export const GROUP_BAR_HEIGHT = 15;
export const GROUP_BAR_PADDING = 15;
export const GROUP_TEXT_DY = 32;
